"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.H3 = void 0;
var LftTypography_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftTypography"));
var react_1 = __importDefault(require("react"));
// o tipo "any" foi adicionado para manter a compatibilidade, remover quando estivermos utilizando somente o lift
var H3 = function (props) {
    return (react_1.default.createElement(LftTypography_1.default, { component: "title", variant: "h3", size: props.size, fontWeight: 'medium', bgColor: props === null || props === void 0 ? void 0 : props.bgColor }, props.children));
};
exports.H3 = H3;
